/**
 * The × of a close button, drawn rather than typed (2026-10-21). A × character
 * sits on the font's baseline and is never quite in the middle of its circle;
 * two strokes are. The button around it centres it (display: grid).
 */
export function CloseMark({ size = 10 }: { size?: number }) {
  return (
    <svg viewBox="0 0 12 12" width={size} height={size} aria-hidden="true" focusable="false" style={{ display: 'block' }}>
      <path d="M1.5 1.5l9 9M10.5 1.5l-9 9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    </svg>
  )
}
